import { cn as e } from "../shared/utils.js";
import "./primitive/index.js";
import { forwardRef as t, useCallback as n } from "react";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { Tooltip as a } from "@base-ui/react/tooltip";
//#region src/tooltip/passive-tooltip.tsx
var o = t(({ arrowProps: t, content: o, popupProps: s, portalProps: c, positionerProps: l, showArrow: u = !0, trigger: d, triggerProps: f, ...p }, m) => {
	let h = n((e) => {
		typeof m == "function" ? m(e) : m && (m.current = e);
	}, [m]);
	return /* @__PURE__ */ i(a.Root, {
		...p,
		children: [/* @__PURE__ */ r(a.Trigger, {
			ref: h,
			delay: 300,
			render: /* @__PURE__ */ r("span", {}),
			...f,
			className: e("outline-none", f?.className),
			"data-slot": "tooltip-trigger",
			children: d
		}), /* @__PURE__ */ r(a.Portal, {
			...c,
			children: /* @__PURE__ */ r(a.Positioner, {
				sideOffset: 6,
				...l,
				className: e("z-50 outline-none", l?.className),
				children: /* @__PURE__ */ i(a.Popup, {
					...s,
					className: e("bg-bg-primary text-text-secondary border-border-100 shadow-1", "max-w-xs rounded-lg border px-3 py-2 text-base font-normal wrap-break-word", "origin-(--transform-origin)", "transition-base transition-[opacity,transform]", "data-starting-style:opacity-0", "data-ending-style:opacity-0 data-ending-style:duration-100 data-ending-style:ease-in", s?.className),
					"data-slot": "tooltip-popup",
					children: [o, u && /* @__PURE__ */ r(a.Arrow, {
						...t,
						className: e("bg-bg-primary border-border-100 size-2 rotate-45 border", "data-[side=top]:-bottom-1 data-[side=top]:border-t-0 data-[side=top]:border-l-0", "data-[side=bottom]:-top-1 data-[side=bottom]:border-r-0 data-[side=bottom]:border-b-0", "data-[side=left]:-right-1 data-[side=left]:border-b-0 data-[side=left]:border-l-0", "data-[side=right]:-left-1 data-[side=right]:border-t-0 data-[side=right]:border-r-0", t?.className)
					})]
				})
			})
		})]
	});
});
o.displayName = "PassiveTooltip";
//#endregion
export { o as PassiveTooltip };
